import { notification } from "antd";
import Api from "../../api";
import API_URL from "../../api/url";

const errorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.Message ||
  error?.message ||
  "Something went wrong";

export const fetchOrganizations = async (params = {}) => {
  try {
    const res = await Api.post(API_URL.ORGANIZATION_LIST, params);
    return Array.isArray(res?.data?.result) ? res.data.result : [];
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return [];
  }
};

export const fetchOrganizationById = async (id) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_BY_ID}/${id}`, {});
    return res?.data?.result || null;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const addOrganization = async (data) => {
  try {
    const res = await Api.post(API_URL.ORGANIZATION_ADD, data);
    notification["success"]({
      message: `Organization created (${res?.data?.result?.OrganizationId || ""})`,
    });
    return res;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const updateOrganization = async (id, data) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_UPDATE}/${id}`, data);
    notification["success"]({ message: "Organization updated successfully!" });
    return res;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const updateOrganizationStatus = async (id, status) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_STATUS_UPDATE}/${id}`, {
      Status: status,
    });
    notification["success"]({ message: "Organization status updated!" });
    return res;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

// Facilities of an organization (id = organization row id)
export const fetchOrganizationFacilities = async (id) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_FACILITIES(id)}/list`, {});
    return Array.isArray(res?.data?.result) ? res.data.result : [];
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return [];
  }
};

export const addOrganizationFacility = async (id, data) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_FACILITIES(id)}/add`, data);
    notification["success"]({ message: "Facility added successfully!" });
    return res;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const updateOrganizationFacility = async (id, facilityId, data) => {
  try {
    const res = await Api.post(
      `${API_URL.ORGANIZATION_FACILITIES(id)}/update/${facilityId}`,
      data
    );
    notification["success"]({ message: "Facility updated successfully!" });
    return res;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const deleteOrganizationFacility = async (id, facilityId) => {
  try {
    const res = await Api.post(
      `${API_URL.ORGANIZATION_FACILITIES(id)}/delete/${facilityId}`,
      {}
    );
    notification["success"]({ message: "Facility deleted successfully!" });
    return res;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

// Partner API token of an organization: returns the token string or null
export const fetchOrganizationToken = async (id) => {
  try {
    const res = await Api.post(API_URL.ORGANIZATION_TOKEN(id), {});
    return res?.data?.result?.Token || null;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const regenerateOrganizationToken = async (id) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_TOKEN(id)}/regenerate`, {});
    notification["success"]({ message: "New token generated!" });
    return res?.data?.result?.Token || null;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

// Facility API token: returns the token string or null
export const fetchFacilityToken = async (id, facilityId) => {
  try {
    const res = await Api.post(API_URL.FACILITY_TOKEN(id, facilityId), {});
    return res?.data?.result?.Token || null;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const regenerateFacilityToken = async (id, facilityId) => {
  try {
    const res = await Api.post(`${API_URL.FACILITY_TOKEN(id, facilityId)}/regenerate`, {});
    notification["success"]({ message: "New token generated!" });
    return res?.data?.result?.Token || null;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

// Partner API integrations: { Types, Methods, Integrations }
export const fetchOrganizationIntegrations = async (id) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_INTEGRATIONS(id)}/list`, {});
    return res?.data?.result || null;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};

export const saveOrganizationIntegration = async (id, data) => {
  try {
    const res = await Api.post(`${API_URL.ORGANIZATION_INTEGRATIONS(id)}/save`, data);
    notification["success"]({ message: "Integration saved successfully!" });
    return res;
  } catch (error) {
    notification["error"]({ message: errorMessage(error) });
    return null;
  }
};
